// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/circle/index.css
// module id = 444
// module chunks = 32